(function () {
  'use strict';

  const state = { league: 'all', brand: 'all', type: 'all', sort: 'manual' };

  const grid         = document.getElementById('z11-grid');
  const countEl      = document.getElementById('z11-count');
  const resultsLabel = document.getElementById('z11-results-label');
  const noResults    = document.getElementById('z11-no-results');
  const activeTags   = document.getElementById('z11-active-tags');
  const activeBar    = document.getElementById('z11-active-filters');
  const clearAllBtn  = document.getElementById('z11-clear-all');
  const resetBtn     = document.getElementById('z11-reset-btn');
  const sortSelect   = document.getElementById('z11-sort-select');

  if (!grid) return;
  const allCards = Array.from(grid.querySelectorAll('.z11-card'));

  function initFromURL() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('league')) state.league = params.get('league');
    if (params.get('brand'))  state.brand  = params.get('brand');
    if (params.get('type'))   state.type   = params.get('type');
    if (params.get('sort'))   state.sort   = params.get('sort');
    if (sortSelect && state.sort) sortSelect.value = state.sort;
  }

  function applyFilters() {
    let visible = 0;
    allCards.forEach(card => {
      const match =
        (state.league === 'all' || card.dataset.league === state.league) &&
        (state.brand  === 'all' || card.dataset.brand  === state.brand)  &&
        (state.type   === 'all' || card.dataset.type   === state.type);
      card.classList.toggle('z11-card--hidden', !match);
      if (match) visible++;
    });
    sortCards();
    if (countEl) countEl.textContent = visible + (visible === 1 ? ' kit' : ' kits');
    if (resultsLabel) resultsLabel.textContent = visible + ' result' + (visible === 1 ? '' : 's');
    if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
    renderActiveTags();
    syncURL();
  }

  function sortCards() {
    const visible = allCards.filter(c => !c.classList.contains('z11-card--hidden'));
    visible.sort((a, b) => {
      switch (state.sort) {
        case 'price-asc':    return parseInt(a.dataset.price) - parseInt(b.dataset.price);
        case 'price-desc':   return parseInt(b.dataset.price) - parseInt(a.dataset.price);
        case 'title-asc':    return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        case 'created-desc': return parseInt(b.dataset.created || 0) - parseInt(a.dataset.created || 0);
        default: return 0;
      }
    });
    visible.forEach(card => grid.appendChild(card));
  }

  function renderActiveTags() {
    if (!activeTags || !activeBar) return;
    activeTags.innerHTML = '';
    const filters = [
      { key: 'league', value: state.league },
      { key: 'brand',  value: state.brand  },
      { key: 'type',   value: state.type   },
    ].filter(f => f.value !== 'all');
    activeBar.style.display = filters.length ? 'flex' : 'none';
    filters.forEach(f => {
      const tag = document.createElement('button');
      tag.className = 'z11-tag';
      tag.innerHTML = f.value + ' <span class="z11-tag__x">×</span>';
      tag.addEventListener('click', () => {
        state[f.key] = 'all';
        updatePillUI(f.key, 'all');
        applyFilters();
      });
      activeTags.appendChild(tag);
    });
  }

  function syncURL() {
    const params = new URLSearchParams();
    if (state.league !== 'all') params.set('league', state.league);
    if (state.brand  !== 'all') params.set('brand',  state.brand);
    if (state.type   !== 'all') params.set('type',   state.type);
    if (state.sort   !== 'manual') params.set('sort', state.sort);
    const newURL = params.toString() ? window.location.pathname + '?' + params.toString() : window.location.pathname;
    window.history.replaceState({}, '', newURL);
  }

  function updatePillUI(filterKey, value) {
    document.querySelectorAll(`[data-filter="${filterKey}"]`).forEach(pill => {
      pill.classList.toggle('z11-pill--active', pill.dataset.value === value);
    });
  }

  function resetFilters() {
    state.league = state.brand = state.type = 'all';
    ['league', 'brand', 'type'].forEach(k => updatePillUI(k, 'all'));
    applyFilters();
  }

  document.querySelectorAll('.z11-pill[data-filter]').forEach(pill => {
    pill.addEventListener('click', () => {
      state[pill.dataset.filter] = pill.dataset.value;
      updatePillUI(pill.dataset.filter, pill.dataset.value);
      applyFilters();
    });
  });

  if (sortSelect) sortSelect.addEventListener('change', () => { state.sort = sortSelect.value; applyFilters(); });
  if (clearAllBtn) clearAllBtn.addEventListener('click', resetFilters);
  if (resetBtn) resetBtn.addEventListener('click', resetFilters);

  grid.addEventListener('submit', function (e) {
    const form = e.target.closest('.z11-card__atc-form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('.z11-card__atc-btn');
    const id  = form.querySelector('[name="id"]').value;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 }),
    })
    .then(() => {
      btn.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; }, 1800);
    })
    .catch(() => { btn.textContent = 'Error – try again'; btn.disabled = false; });
  });

  initFromURL();
  applyFilters();
})();